module.exports = __webpack_public_path__ + "static/img/institution05.4b09e7b.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/institution05.png
// module id = hcRo
// module chunks = 1